<header class="sticky top-0 z-20 shadow-md h-16 flex items-center justify-between p-4 text-white dark:bg-gray-800">
  <!-- Logo and Doctor Name -->
  <div class="flex items-center space-x-2 " [class.hidden]="isMobileSearchVisible">
    <!-- Hide logo and name when mobile search is active -->
    <img src="/assets/images/om_logo_full_h.svg" alt="OrganizeMED Logo" class="h-8 w-auto cursor-pointer" width="150"
      height="32" priority (click)="closeCaseDetails()" data-cy="page-header-img-logo" />
    <span class="text-xs font-medium text-gray-800 dark:text-white md:text-base" data-cy="page-header-text-doctorName"> for {{ doctorName }} </span>
  </div>

  <!-- Desktop Search Bar -->
  @if (showSearch) {
  <div class="hidden md:block flex-grow mx-4" (focusout)="onSearchBlur()" data-cy="page-header-div-desktopSearch">
    <app-search-bar (search)="onSearch($event)"></app-search-bar>
    <!-- Search Results for Desktop -->
    @if (searchResults.length > 0) {
    <div
      class="absolute bg-white dark:bg-gray-700 shadow-lg rounded-md mt-2 w-96 z-10 border border-gray-400 dark:border-gray-600" data-cy="page-header-div-searchResults">
      @for (result of searchResults; track result.id) {
      <a (mousedown)="navigateToResult(result)"
        class="block p-4 hover:bg-gray-100 dark:hover:bg-gray-600 text-gray-900 dark:text-gray-100 cursor-pointer" data-cy="page-header-link-searchResult">
        {{ result.name }} ({{ result.caseType }}) - {{ result.start | date : 'shortDate' }}
      </a>
      }
    </div>
    }
  </div>
  }

  <!-- Mobile Search Icon/Bar -->
  @if (showSearch) {
  <div class="md:hidden flex items-center">
    <button (click)="toggleMobileSearch()" class="text-gray-600 dark:text-gray-300 focus:outline-none items-center p-2" data-cy="page-header-button-mobileSearchToggle">
      <span class="material-symbols-outlined">{{ isMobileSearchVisible ? 'close' : 'search' }}</span>
    </button>
    @if (isMobileSearchVisible) {
    <div
      class="absolute top-0 left-0 w-full h-full bg-white dark:bg-gray-800 flex items-center justify-center pl-8 z-20" data-cy="page-header-div-mobileSearchContainer">
      <app-search-bar (search)="onSearch($event)"></app-search-bar>
      <button (click)="toggleMobileSearch()" class="text-gray-600 dark:text-gray-300 focus:outline-none ml-2" data-cy="page-header-button-mobileSearchClose">
        <span class="material-symbols-outlined m-2">close</span>
      </button>
      <!-- Search Results for Mobile -->
      @if (searchResults.length > 0) {
      <div
        class="absolute bg-white dark:bg-gray-700 shadow-lg rounded-md mt-2 top-16 z-30 p-2 border border-gray-400 dark:border-gray-600" data-cy="page-header-div-mobileSearchResults">
        @for (result of searchResults; track result.id) {
        <a (mousedown)="navigateToResult(result)"
          class="block p-2 hover:bg-gray-100 dark:hover:bg-gray-600 text-gray-900 dark:text-gray-100 cursor-pointer" data-cy="page-header-link-mobileSearchResult">
          {{ result.name }} ({{ result.caseType }}) - {{ result.start | date : 'shortDate' }}
        </a>
        }
      </div>
      }
    </div>
    }
  </div>
  }
</header>